import { useState, useEffect, useRef } from "react";
import GetIcon from "../../../../utils/Icon";
import EditItemModal from "./EditItemModal";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import ConfigureColumns from "./ConfigureColumns";
import Pagination from "../../../../Components/Pagination";

const Table = ({ pageNo, scannedserialNo, list_data, row, fulldata, scanboll, submit }) => {
const getRowColor = (currentcolurraw) => {
  if (!scanboll) return;


  const itemRows = row.Rows.filter(r => r?.item_code === currentcolurraw?.item_code);
  const totalScanQty = itemRows.reduce((sum, r) => sum + Number(r?.picked_qty), 0);
  const tottalqty = itemRows.reduce((sum, r) => sum + Number(r?.qty), 0);

  if (totalScanQty === 0) return 'not-distributed';
  if (totalScanQty === tottalqty) return 'fully-distributed bluebackground';
  if (totalScanQty >= row.qty) return 'bluebackground';
  return 'partially-distributed';
};

  const tableRef = useRef(null);
  const inputRefs = useRef([]);
  const [error, setError] = useState('');
  const [ptype, setptype] = useState("Error");
  const [full_Item_Detail, setfull_Item_Detail] = useState({});
  const [showError, setShowError] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [columeConfModal, setcolumeConfModal] = useState(false);
  const [focusedCell, setFocusedCell] = useState({ rowIndex: null, field: null });
  const [popIndex, setpopIndex] = useState(null);
  // Pagination state
  const [rowsPerPage] = useState(10);

  const [visibleColumns, setVisibleColumns] = useState([
    { name: "S.No", selected: true, key: "sno", width: "7%" },
    { name: "Item Code", selected: true, key: "item_code", width: "17%" },
    { name: "Item Name", selected: true, key: "item_name", width: "25%" },
    { name: "Order Qty", selected: true, key: "order_qty", width: "10%" },
    { name: "Qty", selected: true, key: "qty", width: "10%" },
    { name: "Pick Qty", selected: true, key: "picked_qty", width: "9%" },
    { name: "Bin", selected: true, key: "warehouse", width: "25%" },
    { name: "UOM", selected: true, key: "uom", width: "25%" },
    { name: "Rate", selected: false, key: "rate", width: "10%" },
    { name: "Amount", selected: false, key: "amount", width: "10%" },
    { name: "Reject Qty", selected: false, key: "rejected_qty", width: "80px" },
    { name: "Barcode", selected: false, key: "barcode", width: "80px" },
    { name: "Batch No.", selected: false, key: "batch_no", width: "70px" },
    { name: "Serial No.", selected: false, key: "serial_numbers", width: "70px" },
    { name: "Expiry Date", selected: false, key: "expiry_date", width: "80px" },
    { name: "Settings", selected: true, key: "settings", width: "4%" }
  ]);

  const indexOfLastRow = pageNo.newPageNumber * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = row.Rows.slice(indexOfFirstRow, indexOfLastRow);
  
  useEffect(() => {
    row.setRows(list_data);
  }, [list_data]);

  useEffect(() => {
    if (scanboll) {
      setVisibleColumns([
        { name: "S.No", selected: true, key: "sno", width: "7%" },
        { name: "Item Code", selected: true, key: "item_code", width: "17%" },
        { name: "Item Name", selected: true, key: "item_name", width: "25%" },
        { name: "Order Qty", selected: true, key: "order_qty", width: "9%" },
        { name: "Qty ", selected: true, key: "qty", width: "9%" },
        { name: "Pick Qty", selected: true, key: "picked_qty", width: "9%" },
        { name: "Bin", selected: true, key: "warehouse", width: "14%" },
        { name: "UOM", selected: true, key: "uom", width: "7%" },
        { name: "Rate", selected: false, key: "rate", width: "10%" },
        { name: "Amount", selected: false, key: "amount", width: "10%" },
        { name: "Reject Qty", selected: false, key: "rejected_qty", width: "80px" },
        { name: "Barcode", selected: false, key: "barcode", width: "80px" },
        { name: "Batch No.", selected: false, key: "batch_no", width: "6%" },
        { name: "Serial No.", selected: false, key: "serial_numbers", width: "6%" },
        { name: "Expiry Date", selected: false, key: "expiry_date", width: "80px" },
        { name: "Settings", selected: true, key: "settings", width: "4%" }
      ]);
    }
  }, [scanboll]);

  useEffect(() => {
    const cols = tableRef.current?.querySelectorAll("th") || [];
    cols.forEach((col) => {
      const resizer = document.createElement("div");
      resizer.className = "resizer";
      col.appendChild(resizer);

      let x = 0;
      let w = 0;

      const onMouseDown = (e) => {
        x = e.clientX;
        w = col.offsetWidth;

        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
      };

      const onMouseMove = (e) => {
        const dx = e.clientX - x;
        col.style.width = `${w + dx}px`;
      };

      const onMouseUp = () => {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };

      resizer.addEventListener("mousedown", onMouseDown);
    });
  }, [visibleColumns]);

  useEffect(() => {
    inputRefs.current = inputRefs.current.slice(0, currentRows.length);
  }, [currentRows]);

  const handleKeyDown = (e, rowIndex, field) => {
    const globalIndex = indexOfFirstRow + rowIndex;

    if (field === 'picked_qty') {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        const nextRowIndex = rowIndex + 1;
        if (nextRowIndex < currentRows.length) {
          const nextInput = inputRefs.current[nextRowIndex];
          if (nextInput) {
            nextInput.focus();
            nextInput.select();
          }
        }
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        const prevRowIndex = rowIndex - 1;
        if (prevRowIndex >= 0) {
          const prevInput = inputRefs.current[prevRowIndex];
          if (prevInput) {
            prevInput.focus();
            prevInput.select();
          }
        }
      }
    }
  };

  const openEditModal = (item, index) => {
    const filterdata = row.Rows.filter((realitem) => realitem.item_code == item.item_code && realitem.warehouse == item.warehouse && realitem.batch_no == item.batch_no);
    setpopIndex(row.Rows.findIndex((realitem) => realitem.item_code == item.item_code && realitem.warehouse == item.warehouse && realitem.batch_no == item.batch_no));

    setfull_Item_Detail(filterdata[0]);
    setCurrentItem({ ...item });
    setCurrentIndex(indexOfFirstRow + index);
    setShowEditModal(true);
  };

  const handleItemChange = (serialno) => {
    row.setRows(prevList => {
      const updatedList = [...prevList];
      const itemIndex = updatedList.findIndex(item => item.Scanned_Sno.includes(serialno));
      const matchedItem = updatedList[itemIndex];
      const updatedSerialNo = matchedItem.Scanned_Sno.filter(item => item != serialno);
      const UpdatescannedSerial = scannedserialNo.scannedserialNo.filter(item => item != serialno);
      scannedserialNo.setscannedserialNo(UpdatescannedSerial);
      updatedList[itemIndex] = {
        ...matchedItem,
        Scanned_Sno: updatedSerialNo,
        picked_qty: parseInt(matchedItem.picked_qty) - 1,
      };
      return updatedList;
    })
  }

  const saveEdit = () => {
    const updatedRows = [...row.Rows];
    updatedRows[currentIndex] = currentItem;
    row.setRows(updatedRows);
    setShowEditModal(false);
  };

  const handleInputChange = (index, field, value) => {
    const updatedRows = [...row.Rows];
    const totalQty = parseInt(updatedRows[indexOfFirstRow + index].qty) || 0;
    const newValue = parseInt(value) || 0;

    if (["picked_qty", "rejected_qty", "to_be_picked"].includes(field)) {
      if (newValue > totalQty) {
        setError(`${field.replace("_", " ")} cannot be greater than total quantity (${totalQty})`);
        setShowError(true);
        return;
      }
    }

    updatedRows[indexOfFirstRow + index][field] = value;
    row.setselectRow(updatedRows[indexOfFirstRow + index].item_code)

    row.setRows(updatedRows);
  };

  const handleSaveColumns = (columns) => {
    setVisibleColumns(columns);
  };

  const renderTableHeader = () => {
    return visibleColumns
      .filter(column => column.selected)
      .map((column, index) => {
        if (column.key === "settings") {
          return (
            <th key={index} onClick={() => setcolumeConfModal(true)} style={{ height: '30px', width: column.width, minWidth: column.width }}>
              <GetIcon iconName="IoSettingsOutline" size={13} />
            </th>
          );
        }
        return <th key={index} style={{ height: '30px', width: column.width, minWidth: column.width }}>
          {column.name}</th>;
      });
  };

  const renderTableRow = (rowData, rowIndex) => {
    const globalIndex = indexOfFirstRow + rowIndex;
    return visibleColumns
      .filter(column => column.selected)
      .map((column, colIndex) => {
        const key = column.key;

        if (key === "sno") {
          return (
            <td key={colIndex} className="p-0" >
              <p className="mb-0" >
                {rowData?.["idx"]}
                {/* {globalIndex + 1} */}
              </p>
            </td>
          );
        }
        if (key === "settings") {
          return (
            <td key={colIndex} className="p-0" >
              <span onClick={() => openEditModal(rowData, rowIndex)} >
                <GetIcon iconName="MdOutlineEdit" size={15} />
              </span>
            </td>
          );
        }

        if (["picked_qty", "rejected_qty", "expiry_date", "manufacturing_date", "to_be_picked"].includes(key)) {
          return (
            <td key={colIndex} className="p-0 d-flex justify-content-center" style={{ border: focusedCell.rowIndex === globalIndex && focusedCell.field === key ? '0.3px solid #270b79' : '' }}>
              {submit ? (
                <span style={{ fontSize: '0.8rem', width: key === "picked_qty" ? '44%' : '', lineHeight: '2rem' }}>
                  {rowData[key]}
                </span>
              ) : (
                <input
                  ref={el => inputRefs.current[rowIndex] = el}
                  type={key.includes("date") ? "date" : "text"}
                  className="form-control noborder"
                  onFocus={() => setFocusedCell({ rowIndex: globalIndex, field: key })}
                  onBlur={() => setFocusedCell({ rowIndex: null, field: null })}
                  onKeyDown={(e) => handleKeyDown(e, rowIndex, key)}
                  style={{ fontSize: '0.8rem', background: 'transparent', width: key === "picked_qty" ? '44%' : '' }}
                  value={rowData[key]}
                  onChange={(e) => handleInputChange(rowIndex, key, e.target.value)}
                />
              )}
            </td>
          );
        }

        if (key === "batch_no") {
          return (
            <td key={colIndex} className="p-0" >
              <p className="mb-0" >
                {rowData["picked_qty"] > 0 ? rowData["batch_no"] : ''}
              </p>
            </td>
          );
        }

        if (key === "serial_numbers") {
          return (
            <td key={colIndex} className="p-0" >
              <p className="mb-0" >
                {rowData["Scanned_Sno"].length > 1 ? `${rowData["Scanned_Sno"][0]}...` : rowData["Scanned_Sno"][0]}
              </p>
            </td>
          );
        }
        return <td key={colIndex} className="p-0">
          <p className="mb-0" >
            {key == "amount" || key == "rate" ? `₹${rowData?.[key]}` : rowData?.[key]}
          </p>
        </td>;
      });
  };

  return (
    <>
      <table className="table table-bordered" style={{ borderCollapse: 'separate', borderSpacing: '0px' }} ref={tableRef} >
        <thead className="tableHead1">
          <tr style={{ height: '30px', }}>
            {renderTableHeader()}
          </tr>
        </thead>
        <tbody>
          {currentRows.map((crrow, index) => (
            <tr style={{ height: '30px', verticalAlign: 'middle' }} className={` ${getRowColor(crrow)} ${crrow?.item_code == row?.selectRow?.item_code ? 'blinkbackground' : ''}`} key={index}>{renderTableRow(crrow, index)}</tr>
          ))}
        </tbody>
      </table>
      <div className="d-flex justify-content-between align-items-center mt-1 mb-3 centerpagination">
        <div>
          <p style={{ textDecoration: "none" }} className="createbtn m-0">
            <span className="iconbox" style={{ padding: '0px 1px' }}>
              <GetIcon iconName="MdOutlineFileDownload" size={13} />
            </span>
            Download
          </p>
        </div>

        {row.Rows.length > 10 ? <Pagination
          setCurrentPage={pageNo.setnewPageNumber}
          pageSize={rowsPerPage}
          totalrecords={row.Rows.length}
          currentPage={pageNo.newPageNumber}
        /> : ''}

        {row.Rows.length > 10 ? <div>
          <span className="px-2" style={{ fontSize: '12px', color: '#270B79', position: 'relative', top: '-6px' }}>
            Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, row.Rows.length)} of {row.Rows.length} entries
          </span>
        </div> : ''}
      </div>

      <ConfigureColumns
        show={columeConfModal}
        onClose={() => setcolumeConfModal(false)}
        onSave={handleSaveColumns}
        initialFields={visibleColumns}
      />

      <EditItemModal
        tabData={fulldata}
        itemDataReal={row.Rows[popIndex]}
        show={showEditModal}
        onClose={() => setShowEditModal(false)}
        full_Item_Detail={full_Item_Detail}
        onChange={handleItemChange}
        onSave={() => { }}
      />

      <ApiResponseBox
        poptype={ptype}
        show={showError}
        errorMessage={error}
        onClose={() => setShowError(false)}
      />
    </>
  );
};

export default Table;